import { useEffect, useRef } from "react";
import { useAuth } from "context/AuthContext";
import { callAlertOptIn } from "api/MuyeonApi";
import { showToast } from "util/appToast";
import { trackClick } from "util/appAnalytics";

/**
 * ★ 2026-11-02 '공고 알림 받기' 신청 — 공고 목록 가입 버튼(JobBoardSignupCta)을 누른 비회원이
 *  가입·로그인하고 돌아오면 채용·대타 새 공고 알림을 켠다(POST /me/alert-prefs/opt-in).
 *  가입 흐름은 카카오·이메일·본인인증으로 페이지를 떠났다 돌아오므로, 누른 사실을 localStorage 에 남겨 두고
 *  로그인 상태가 되면 여기서 한 번 처리한다. 하루가 지난 표시는 버린다(오래전에 누른 버튼으로 켜지지 않게).
 *  화면을 그리지 않는다. App 루트에 둔다.
 */
const KEY = "muyeon.alertOptIn.pending";
const TTL_MS = 24 * 60 * 60 * 1000;

/** 버튼을 눌렀다는 표시 — 가입·로그인 뒤 AlertOptInHost 가 처리한다. */
export function markAlertOptIn(source) {
  try { localStorage.setItem(KEY, JSON.stringify({ source, at: Date.now() })); } catch (e) { /* noop */ }
}

function readPending() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!v || typeof v.source !== "string" || Date.now() - Number(v.at) > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return v;
  } catch (e) { return null; }
}

export default function AlertOptInHost() {
  const { isLoggedIn, user } = useAuth();
  const busy = useRef(false);
  useEffect(() => {
    // 소셜 가입은 추가정보(본인인증)를 마쳐야 가입 완료 — 그 전에는 기다린다.
    if (!isLoggedIn || !user || user.signupIncomplete || busy.current) return;
    const pending = readPending();
    if (!pending) return;
    busy.current = true;
    callAlertOptIn(pending.source)
      .then(() => {
        try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
        trackClick("alert:opt_in", { props: { source: pending.source } });
        showToast("새 공고 알림을 켰어요. 알림 설정에서 바꿀 수 있어요.", 3000);
      })
      .catch(() => { /* 실패하면 표시를 남겨 다음 진입에서 다시 시도 */ })
      .finally(() => { busy.current = false; });
  }, [isLoggedIn, user]);
  return null;
}
